import { getEnv, types } from "mobx-state-tree";
import { StorageModel } from "../storage/StorageModel";
import { endpoints } from "../api/ApiEndpoints";
import { api } from "../api/ApiService";
import { organizationSubscriptionService } from "../organization/OrganizationSubscription";
import { reaction } from "mobx";

export interface MainCodeColor {
    mainCode: string,
    color: string
}

const MainCodeColorStorageModel = types.compose(
    StorageModel,
    types.model({
        colors: types.optional(types.frozen<MainCodeColor[]>(), [])
    }).views((self) => ({
        get endpoint() {
            return endpoints.get("get_main_code_colors");
        },
        get isLoading() {
            return self.colors.length <= 0;
        },
        get canLoadItems() {
            return getEnv(self).organizationSubscriptionService.key;
        },
    })).actions((self) => {
        return {
            mapResponse(response: MainCodeColor[]) {
                self.colors = response;
            },
        }
    })
)

export const mainCodeColorStorage = MainCodeColorStorageModel.create({}, { api, organizationSubscriptionService });

reaction(
    () => organizationSubscriptionService.key,
    async () => {
        await mainCodeColorStorage.load();
    }
);